import { Avatar, Chip } from '@mui/material';

export interface CourseProps {
  seats?: number | null;
  shorthand: string;
}

export function CourseChip({ seats, shorthand }: CourseProps) {
  return (
    <Chip
      label={shorthand}
      avatar={<Avatar>{seats}</Avatar>}
      variant="outlined"
      style={{ maxWidth: '10em' }}
    />
  );
}
